import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import HelpLink from 'App/HelpLink/HelpLink';
import { HELP_LINKS_CATEGORIES } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';
import emptyCategories from './empty-categories.png';

function CategoriesListEmpty({
  onClose,
}: {
  onClose: () => void;
}): JSX.Element {
  const t = useTranslationCatalog();
  const language = useTranslationLanguage();
  return (
    <InitialScreen paddingTop="20">
      <InitialScreen.Hero
        subtitle={t('categories.title').toUpperCase()}
        title={t('categories.emptyResults.title')}
        description={t('categories.emptyResults.body')}
        image={
          <img
            width="100%"
            height="auto"
            src={emptyCategories}
            alt="empty-categories"
          />
        }
        actions={
          <Button onClick={onClose} appearance="primary">
            {t('categories.action')}
          </Button>
        }
      />
      <Box
        display="flex"
        flexDirection="row"
        gap="2"
        justifyContent="center"
        mt="5"
        paddingTop="5"
      >
        <HelpLink
          title={t('helpLink.organizeCategories')}
          linkURL={HELP_LINKS_CATEGORIES[language]}
          previousValue="category_list"
          currentViewTracking={t('helpLink.organizeCategoriesTrackingName')}
          icon="both"
          showInMobile
        />
      </Box>
    </InitialScreen>
  );
}

export default CategoriesListEmpty;
